import { createTranslations } from '@npco/common-utils-translations'

export const bpayTargetInputTranslations = createTranslations({
  selectLabel: 'Contact or Biller Code',
  selectPlaceholder: 'Enter Contact or Code',
  selectItemContactSublabel: '{count} BPAY Detail{plural} saved',
  addBusinessButton: '+ Add Business',
})
